import { Loading } from 'element-ui';
const LoadingWrapper = Loading;
export default LoadingWrapper;
